import _extends from "@babel/runtime/helpers/extends";
import React, { useState, useEffect, useMemo } from 'react';
import Input from '@uiw/react-input';
import Dropdown from '@uiw/react-dropdown';
import Menu from '@uiw/react-menu';
import Icon from '@uiw/react-icon';
import "./style/index.css";
import { jsx as _jsx } from "react/jsx-runtime";
function Cascader(props) {
  var {
    value,
    onChange,
    onSearch,
    expandTrigger = 'click',
    size,
    disabled,
    allowClear,
    placeholder,
    prefixCls = 'w-cascader',
    className,
    style = {
      width: 200
    },
    option = [],
    others,
    inputProps
  } = props;
  var cls = [prefixCls, className].filter(Boolean).join(' ').trim();
  var [innerIsOpen, setInnerIsOpen] = useState(false);
  var [selectedValue, setSelectedValue] = useState([]);
  var [selectIconType, setSelectIconType] = useState('');
  var [searchText, setSearchText] = useState('');
  var [searchOn, setSearchOn] = useState(false);
  var [inputValue, setInputValue] = useState('');
  var [searchOption, setSearchOption] = useState();
  useEffect(() => {
    if (onSearch) {
      var tempOptions = [];
      iteratorOption(option, opt => {
        var label = opt.map(m => m.label).join(' / ');
        tempOptions.push({
          label,
          options: opt
        });
      });
      setSearchOption(tempOptions);
    }
  }, [onSearch]);
  var iteratorOption = function iteratorOption(options, cb, opts) {
    if (opts === void 0) {
      opts = [];
    }
    options.map(opt => {
      var optsTemp = [...opts, opt];
      if (opt.children) {
        iteratorOption(opt.children, cb, optsTemp);
      } else {
        cb == null || cb(optsTemp);
      }
    });
  };
  useEffect(() => {
    if (value) {
      var valueTemp = [];
      var optChildren = option;
      value == null || value.map(item => {
        var findOpt = optChildren.find(opt => opt.value === item);
        optChildren = (findOpt == null ? void 0 : findOpt.children) || [];
        valueTemp.push(_extends({
          label: item,
          value: item
        }, findOpt));
      });
      setSelectedValue(valueTemp);
    }
  }, [value]);
  function onVisibleChange(isOpen) {
    setInnerIsOpen(isOpen);
  }
  function renderSelectIcon(type) {
    var selectIconType;
    if (type === 'enter' && allowClear && selectedValue.length > 0) {
      selectIconType = 'close';
    } else {
      selectIconType = '';
    }
    setSelectIconType(selectIconType);
  }
  var searchItemClick = options => {
    setSearchText('');
    setInnerIsOpen(false);
    handelChange(false, options);
  };
  var handleItemClick = (optionsItem, level) => {
    selectedValue.splice(level, selectedValue.length - level, optionsItem);
    if (!optionsItem.children) setInnerIsOpen(false);
    handelChange(true, selectedValue);
  };
  var handelChange = (isSeleted, selectedValue) => {
    setSelectedValue([...selectedValue]);
    var value = selectedValue.map(item => item.value);
    onChange == null || onChange(isSeleted, value, selectedValue);
  };
  var onClear = e => {
    e.stopPropagation();
    handelChange(false, []);
  };
  var handelSearch = searchText => {
    setSearchText(searchText);
  };
  var inputChange = e => {
    if (!innerIsOpen) {
      setInnerIsOpen(!innerIsOpen);
    }
    var value = e.target.value;
    onSearch && handelSearch(value);
  };
  var widths = (style == null ? void 0 : style.width) * 0.7 || undefined;
  var trigger = useMemo(() => {
    return (cb, click) => {
      var triggers = {
        onClick: () => {},
        onMouseOver: () => {}
      };
      var callback = () => {
        cb();
      };
      if (expandTrigger === 'click' || click) {
        triggers.onClick = callback;
      } else if (expandTrigger === 'hover') {
        triggers.onMouseOver = callback;
      }
      return triggers;
    };
  }, []);
  var OptionIter = function OptionIter(option, level) {
    if (level === void 0) {
      level = 0;
    }
    if (!option) return;
    return /*#__PURE__*/_jsx(Menu, {
      bordered: true,
      style: {
        minHeight: 25,
        minWidth: widths,
        overflowY: 'scroll',
        width: widths
      },
      children: !option || option.length === 0 ? /*#__PURE__*/_jsx("div", {
        style: {
          color: '#c7c7c7',
          fontSize: 12
        },
        children: '没有数据'
      }) : option.map((opt, index) => {
        var _selectedValue$level, _opt$children;
        var active = ((_selectedValue$level = selectedValue[level]) == null ? void 0 : _selectedValue$level.value) === opt.value;
        return /*#__PURE__*/_jsx(Menu.Item, _extends({
          active: active,
          text: opt.label,
          addonAfter: opt.children ? /*#__PURE__*/_jsx(Icon, {
            type: "right"
          }) : undefined
        }, trigger(() => {
          handleItemClick(opt, level);
        }, !((_opt$children = opt.children) != null && _opt$children.length))), index);
      })
    }, level);
  };
  useEffect(() => {
    var inputValue = selectedValue.map(opt => opt.label).join(' / ');
    setInputValue(inputValue);
  }, [selectedValue]);
  return /*#__PURE__*/_jsx(Dropdown, _extends({
    className: cls,
    trigger: "click",
    style: {
      marginTop: 5
    },
    overlayStyl: {
      width: 100
    },
    disabled: disabled
  }, others, {
    onVisibleChange: onVisibleChange,
    isOpen: innerIsOpen,
    menu: !searchText ? /*#__PURE__*/_jsx("div", {
      style: {
        display: 'flex'
      },
      children: new Array(selectedValue.length + 1).fill(0).map((_, index) => {
        var _selectedValue;
        var options = index ? (_selectedValue = selectedValue[index - 1]) == null ? void 0 : _selectedValue.children : option;
        return OptionIter(options, index);
      }).filter(m => !!m)
    }) : /*#__PURE__*/_jsx(Menu, {
      bordered: true,
      style: {
        minHeight: 25,
        minWidth: style == null ? void 0 : style.width,
        overflowY: 'scroll',
        width: style == null ? void 0 : style.width
      },
      children: !searchOption || searchOption.length === 0 ? /*#__PURE__*/_jsx("div", {
        style: {
          color: '#c7c7c7',
          fontSize: 12
        },
        children: '没有数据'
      }) : searchOption.filter(opt => opt.label.includes(searchText.trim())).map((opt, index) => {
        return /*#__PURE__*/_jsx(Menu.Item, {
          text: opt.label,
          onClick: () => searchItemClick(opt.options)
        }, index);
      })
    }),
    children: /*#__PURE__*/_jsx("span", {
      onMouseLeave: () => renderSelectIcon('leave'),
      onMouseOver: () => renderSelectIcon('enter'),
      children: /*#__PURE__*/_jsx(Input, _extends({}, inputProps, {
        value: searchOn ? searchText : inputValue,
        onChange: inputChange,
        size: size,
        disabled: disabled,
        placeholder: searchOn ? inputValue : placeholder,
        style: style,
        onFocus: () => onSearch && setSearchOn(true),
        onBlur: () => onSearch && setSearchOn(false),
        readOnly: !onSearch,
        addonAfter: /*#__PURE__*/_jsx("span", {
          style: {
            width: 'auto'
          },
          children: !disabled && selectIconType === 'close' && /*#__PURE__*/_jsx(Icon, {
            type: selectIconType,
            onClick: onClear,
            className: prefixCls + "-close"
          })
        })
      }))
    })
  }));
}
export default Cascader;